import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'cms-content-load',
  templateUrl: './cms-content-load.component.html',
  styleUrls: ['./cms-content-load.component.scss']
})
export class CmsContentLoadComponent implements OnInit {
  @Input() data:any;
  sku: any;
  currentLanguage: string;
  displayName: any;
  learnMore: any;

  constructor(
    private cdr: ChangeDetectorRef,
    private modalController: ModalController) { }

  ngOnInit() {
    this.sku = this.data.sku;
    this.displayName = this.sku?.name;
    this.currentLanguage = localStorage.getItem('language');
    if(this.sku){
      if(this.currentLanguage == 'ar'){
        this.learnMore = this.sku?.learnMore;
        this.displayName = (this.sku?.displayNameAr) ? this.sku?.displayNameAr :this.sku?.displayName;
        this.cdr.detectChanges()
      }
      else {
        this.learnMore = this.sku?.learnMore;
        this.displayName = this.sku?.name;
        this.cdr.detectChanges()
      }
    }
  }
  close(){
    // if(this.agreedOnterms){
    //   this.GAS.termsAndConditions('Agree', this.plan);
    // }
    this.modalController.dismiss({close:true});
  }
}
